export default __webpack_public_path__ + "img/map-marker-adult_resources.2f07e129.png";